import styled from 'styled-components';
import { layout, media, colorUtils } from 'src/components/base';
import { Floater } from '@prisjakt/ui/floater';
import { Badge } from '@prisjakt/ui/badge';
import { ButtonText } from '@prisjakt/ui/button';
import { TextButton, TonalButton } from '@prisjakt/ui/button/variants';
import { zindex } from 'src/ui/zindex';

const DESKTOP_DIALOG = {
  MIN_WIDTH: 200,
  MAX_WIDTH: 320,
  MIN_HEIGHT: 130,
  MAX_HEIGHT: 356,
};

export const FilterPanelWrapper = styled.div`
  background: ${p => p.theme.bg.primary};
  padding: ${layout.measurements.spacing100};
  border-radius: 8px;
  width: 100%;
  margin-bottom: ${layout.measurements.spacing050};
  border: 1px solid ${p => p.theme.lines.primary};
  box-shadow: ${p =>
    `0px 2px 8px 0px ${colorUtils.setRgbaAlpha(p.theme.colors.base800, 0.24)}`};

  ${media.mediumUp`
    min-width: ${DESKTOP_DIALOG.MIN_WIDTH}px;
    max-width: ${DESKTOP_DIALOG.MAX_WIDTH}px;
    min-height: ${DESKTOP_DIALOG.MIN_HEIGHT}px;
    max-height: ${DESKTOP_DIALOG.MAX_HEIGHT}px;
    overflow-y: auto;
  `}
`;

export const FiltersDropDown = styled(Floater)`
  z-index: ${zindex.menu.offerlistFilters};
  transform: translate(0.5rem, 4.5em);
`;

export const FilterBlocker = styled.div`
  z-index: ${zindex.overlay};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;

export const FilterPanel = styled.div`
  display: grid;
  gap: ${layout.measurements.spacing150};
  width: 100%;

  grid-template-rows: auto;
  grid-auto-flow: row;
  grid-template-columns: 1fr;

  ${media.mediumDown`
    grid-template-rows: auto;
    grid-auto-flow: row;
    grid-template-columns: 1fr;
  `};
`;

export const FilterRow = styled.div`
  > span {
    display: block;
    margin-bottom: ${layout.measurements.spacing050};
  }
`;

export const FilterOptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0;
`;

export const CheckboxClickarea = styled.div``;

export const ButtonBadge = styled(Badge)`
  background-color: ${p => p.theme.colors.maybeBlue500};
  position: absolute;
  top: -30%;
  right: -${layout.measurements.spacing075};

  > span {
    color: ${p => p.theme.colors.base0};
  }
`;

export const ScrollingFiltersList = styled.div`
  width: 100%;
  overflow-x: auto;

  ${media.smallOnly`
    width: 100vw;
    overflow-x: auto;
    position: relative;
    left: -${layout.measurements.spacing050};
  `}
`;

export const ScrollingFiltersListWrapper = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  gap: ${layout.measurements.spacing050};

  ${media.mediumUp`
    flex-wrap: wrap;
    
  `}

  ${media.smallOnly`
    > li:first-child { padding-left: ${layout.measurements.spacing050} }
    > li:last-child { padding-right: ${layout.measurements.spacing050} }
  `}
`;

export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${layout.measurements.spacing150};
  margin: ${layout.measurements.spacing100} 0;
`;

export const StyledClearButton = styled(TextButton)`
  && {
    margin-bottom: 0;
  }
`;

export const StyledTick = styled(TonalButton)`
  && {
    margin-bottom: 0;
  }
`;

export const StyledButtonText = styled(ButtonText)`
  max-width: 145px;
  word-break: break-all;
`;
